import React from "react";

const EditPicButton = ({ text, disabledOn, onClick, children }) => {
  return (
    <button className="createPicButton" disabled={disabledOn} onClick={onClick}>
      <div className="createPicIcons">{children}</div>
      <br></br>
      <div className="w-100 position-absolute createPicButtonPads">{text}</div>
    </button>
  );
};

export default EditPicButton;
